import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (4).png'
function MeasurementTracking() {

  const carbonData = [
    {
      title: "Methodology:",
      description: "A systematic and standardized set of rules, procedures, and calculations used to quantify and verify greenhouse gas emissions or removals associated with a particular project or activity."
    },
    {
      title: "Carbon tracking:",
      description: "The systematic monitoring, recording, and reporting of an entity's greenhouse gas emissions over time, often involving the use of software, tools, or methodologies to track and manage carbon footprints."
    },
    {
      title: "Emission factor:",
      description: "A coefficient that quantifies the amount of greenhouse gas emissions produced per unit of activity, typically expressed as emissions per unit of energy produced or consumed."
    }
  ];


  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-['SF_Pro_Display'] font-medium text-6xl leading-[76px] text-center text-[#141414]">
          Measurement & Tracking
        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full max-w-[1200px] h-[552px] left-1/2  -translate-x-1/2 top-[275px] rounded-2xl  object-fill"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>

 
 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
        Measurement & Tracking
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default MeasurementTracking
